import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import { MiniLessonSectionComponent } from './mini-lesson-section/mini-lesson-section.component';
import { MiniLessonSectionHeaderComponent } from './mini-lesson-section-header/mini-lesson-section-header.component';
import { MiniLessonCarouselComponent } from './mini-lesson-carousel/mini-lesson-carousel.component';
import { MiniLessonTileErrorComponent } from './mini-lesson-tile-error/mini-lesson-tile-error.component';
import { MiniLessonTileCompleteComponent } from './mini-lesson-tile-complete/mini-lesson-tile-complete.component';
import { MiniLessonTileComponent } from './mini-lesson-tile/mini-lesson-tile.component';
import { MiniLessonInfoBannerComponent } from './mini-lesson-info-banner/mini-lesson-info-banner.component';
import { MiniLessonTileComingSoonComponent } from './mini-lesson-tile-coming-soon/mini-lesson-tile-coming-soon.component';
import { GenericTileModule } from '../generic-tile/generic-tile.module';
import { GenericTileBodyModule } from '../../components/generic-tile-body/generic-tile-body.component';
import { TakeUnitQuizConfirmModalComponent } from './take-unit-quiz/take-unit-quiz-confirm-modal.component';
import { TakeUnitQuizLockedModalComponent } from './take-unit-quiz/take-unit-quiz-locked-modal.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        GenericTileModule,
        GenericTileBodyModule,
    ],
    declarations: [
        MiniLessonSectionComponent,
        MiniLessonSectionHeaderComponent,
        MiniLessonCarouselComponent,
        MiniLessonTileErrorComponent,
        MiniLessonTileCompleteComponent,
        MiniLessonTileComponent,
        MiniLessonInfoBannerComponent,
        MiniLessonTileComingSoonComponent,
        TakeUnitQuizConfirmModalComponent,
        TakeUnitQuizLockedModalComponent
    ],
    entryComponents: [TakeUnitQuizConfirmModalComponent, TakeUnitQuizLockedModalComponent],
    exports: [MiniLessonSectionComponent]
})
export class MiniLessonSectionModule { }



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-section.module.ts